import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
const tr = require("./translations/tr.json");
const en = require("./translations/en.json");

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: "kunduz",
    fallbackLng: "tr",
    debug: (process.env.ENV == "development"),
    interpolation: {
      escapeValue: false
    },
    resources: {
      "tr": tr,
      "en": en
    },
    react: {
      wait: true
    }
  });

export default i18n;